import React, { useEffect, useState } from 'react';
import getCurrentBrand from "../utils/getCurrentBrand";
import JwtStore from "../flux/JwtStore";
import feedbackMakeHelpConfiguration from "../utils/feedbackMakeHelpConfiguration";
import Header from '../components/organisms/Header';
import themeResponsiveProperty
  from '../components/responsive/themeResponsiveProperty';
import { useTheme } from 'styled-components';

const defaultFeedbackCommonProperties = {
  name: null,
  email: null,
  boutique: null,
};

export default function Help() {
  const theme = useTheme();
  const [feedbackCommonProperties, setFeedbackCommonProperties] = useState(defaultFeedbackCommonProperties);

  useEffect(function () {
    const subscription = JwtStore.addListener(() => {
      setFeedbackCommonProperties({
        name: `${JwtStore.getUserFirstName()} ${JwtStore.getUserLastName()} (${JwtStore.getUsername()})`,
        email: JwtStore.getMail(),
        boutique: JwtStore.getStores().join(', '),
      });
    });

    return function() {
      subscription.remove();
    }
  }, [])

  const url = `https://goresponsa.com/integrations/valentino/training_app?hide_question_subject=true&question_subject_value=Help&question_form_subject_position=down&question_form_details_position=down&auto_tag=${getCurrentBrand()}&custom_form=${encodeURIComponent(feedbackMakeHelpConfiguration(feedbackCommonProperties))}`;

  return (
    <React.Fragment>
      <Header actions={themeResponsiveProperty(['back'], undefined)({ theme })} />
      <iframe title="feedback-help-modal" src={url} frameBorder="0" style={{ fontSize: 0 }} />
    </React.Fragment>
  );
};
